export const ENTRYPOINT_ID = '54736f0e-415b-4b1f-b9ad-88042b17120b';
export const FEEDBACK_COLLECTOR_ID = 'ddac4251-3a49-462d-8a6b-f602fe8ac06a';
